// extracted by mini-css-extract-plugin
export default {"Hero":"hero_Hero__6kC2Y","subline":"hero_subline__40XbA","headline":"hero_headline__6xEzN","sidebar":"hero_sidebar__iDN+s","video":"hero_video__SIbsR"};